<script setup>
	import { ref } from 'vue'
  	import MediaModal from "@/components/home/MediaModal.vue";

	//reactive field proxies
	const showMediaModal = ref(false)

	//binding to invoke method on child componenet
	const childRefMediaModal = ref({})

	//properties set by parent
	const props = defineProps({
		fileName: {
			type: String,
			required: true,
		}
	})

	//reactive field proxies
	const title = ref(null)
	const fileName = ref(null)
	const poster = ref(null)
	const source = ref(null)
	const description = ref(null)
	const indicator = ref(null)

	//Methods
	async function getText(file) {
		let x = await fetch(file);
		let y = await x.text();
		let cardObj = JSON.parse(y);

		title.value = cardObj.title
		source.value = import.meta.env.VITE_BASE_URL + cardObj.filePath
		poster.value = import.meta.env.VITE_BASE_URL + cardObj.poster
		//description.value = cardObj.description
		//indicator.value = encodeURIComponent(cardObj.indicator)
	}

	function closeMediaModal() {
		showMediaModal.value = false
	}
  	function openMediaModal() {
		//if(isSmallScreen) toggleMenu()
		showMediaModal.value = true
	}	

	//initial method run on page load
	let url = import.meta.env.VITE_BASE_URL + "/json/" + props.fileName
	getText(url);

</script>

<template>
	<MediaModal :isOpen="showMediaModal" :source="source" :poster="poster" @closeMediaModal="closeMediaModal" />
	<div class="card">
		<section class="image-container">
			<img class="card-image" v-bind:src="poster" alt="Poster" />
			<div class="video-start">
				<span class="video-icon" ref="childRefMediaModal" @click="openMediaModal" v-bind:title="title"><i class="fa fa-regular fa-circle-play"></i></span>
			</div>
		</section>
	</div>
</template>

<style scoped>
.card {
	display: flex;
	flex-direction: column;
	/*margin-bottom: 1.8rem;*/
	align-items: center;
	gap: 0.625rem;
	/*background: var(--surface-color-IndicatorBlue); */
	border-radius: var(--radius-xl, 0.75rem);
	height: auto;
  	width: 48%;
	/*max-width: 30rem;*/
}
.image-container {
	position: relative; /* Establishes a positioning context for absolute children */
  	display: inline-block; /* Helps contain the image dimensions */
	/*width: 302px;
	height: 178px;*/
	/* background: var(--surface-color-IndicatorBlue); */
	box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.10);
	border-radius: var(--radius-xl, 0.75rem);
}

.video-start {
	display: flex;
	justify-content: center; /* Centers content horizontally (main axis) */
	align-items: center;   /* Centers content vertically (cross axis) */
	position: absolute; /* Positions the div relative to its parent container */
	top: 0; /* Aligns to the top edge of the container */
	left: 0; /* Aligns to the left edge of the container */
	width: 100%; /* Makes the overlay cover the full width */
	height: 100%; /* Makes the overlay cover the full height */
	background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black background */
	color: var(--icons-icon-cta-reverse, #FFF);
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: var(--radius-xl, 0.75rem);
}
.video-icon {
	color: var(--icons-icon-cta-reverse, #FFF);
	text-align: center;
	/*font-family: "Font Awesome 6 Pro";*/
	font-size: 64px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	cursor: pointer;
}
.card-image {
	width: 100%;      /* Image takes the full width of its parent */
	height: 100%;     /* Image takes the full height of its parent */
	object-fit: cover; /* or contain, fill, etc. */
	/*position: relative; /* Establishes a positioning context for absolute children */
  	/*display: inline-block; /* Helps contain the image dimensions */
	/*height: 10.648rem;*/
	/*align-self: stretch;*/
	/*aspect-ratio: 325.00/170.37;*/

	border-radius: var(--radius-xl, 0.75rem);
	/*background: var(--surface-color-IndicatorBlue); */

	/* background: url(<path-to-image>) lightgray -32.614px -59.754px / 119.228% 208.3% no-repeat; */
}
.card-image img {
  display: block; /* Removes default bottom margin from images */
  width: 100%; /* Ensures the image fits the container width */
  height: auto;
  border-radius: var(--radius-xl, 0.75rem);
  opacity: 0.5;
}
@media (min-width: 1800px) {
  .card {
    flex: 100;
  }
}
@media (max-width: 900px) {
  .card {
    width: 100%;
  }
}

</style>